import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CandidateSingleView from "../../components/CandidateSingleView";
import Dashboard from "../../layouts/Dashboard";
import isConsultant from "../../services/isConsultant";


function ApplicationList() {

  // Uncommon Hooks
  const { id } = useParams();

  return (
    <div>
    {!isConsultant() && <Dashboard title="Candidate Profile">
      <CandidateSingleView id={id} />
    </Dashboard>}
    </div>
  );
}

export default ApplicationList;
